import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

const initialState = {
  soundOn: true,
  successSound: 1,
  failSound: 1,
};

const store = (set) => ({
  ...initialState,

  setSoundOn: (val) => {
    set((prev) => ({ ...prev, soundOn: val }));
  },
  setSuccessSound: (val) => {
    set((prev) => ({ ...prev, successSound: val }));
  },
  setFailSound: (val) => {
    set((prev) => ({ ...prev, failSound: val }));
  },
  reset: () => {
    set(initialState);
  },
});

const soundStore = create(
  persist(store, {
    name: 'sound',
    storage: createJSONStorage(() => localStorage),
  }),
);

export default soundStore;
